import { BaseConfig } from "../config.interface";
import { Color } from "../util";

interface IChipConfig {
    color?: Color;
    style?: 'default' | 'outlined';
    removable?: boolean;
}


export class ChipConfig extends BaseConfig<IChipConfig> implements IChipConfig {
    /**
     * Color of the chip.
     * @values 'info' | 'success' | 'warn' | 'danger' | "primary" | "secondary" | 'text' | 'text-inverse' | HEX, HSL or RGB(A)
     */
    color?: Color;
    style?: 'default' | 'outlined';
    /**
     * Determines if the chip is removable.
     */
    removable?: boolean;

    /**
     * @theme Base
     */
    static baseTheme = {
        /**
         * Default configuration.
         * Color is "secondary".
         */
        Default: new ChipConfig({
            color: 'secondary',
            style: 'default',
        }),
        Outlined: new ChipConfig({
            color: 'secondary',
            style: 'outlined',
        }),
        /**
         * Color is "primary".
         * 
         */
        Primary: new ChipConfig({
            color: 'primary',
            style: 'default',
        }),
        OutlinedPrimary: new ChipConfig({
            color: 'primary',
            style: 'outlined',
        }),

        Text: new ChipConfig({
            color: 'text',
            style: 'default',
        }),
        OutlinedText: new ChipConfig({
            color: 'text',
            style: 'outlined',
        }),

        /**
         * Color is "info".
         * 
         */
        Info: new ChipConfig({
            color: 'info',
            style: 'default',
        }),
        /**
         * Color is "warn".
         * 
         */
        Warning: new ChipConfig({
            color: 'warn',
            style: 'default',
        }),
        /**
         * Color is "danger".
         * 
         */
        Danger: new ChipConfig({
            color: 'danger',
            style: 'default',
        }),
        /**
         * Color is "success".
         * 
         */
        Success: new ChipConfig({
            color: 'success',
            style: 'default',
        }),
    };
}

